import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { MEMBER_TABS, type MemberTab } from '@/features/access/access-tabs';
import { MemberDetailPage } from '@/features/access/members/member-detail-page';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

export const Route = createFileRoute('/$tenant/members/$userId')({
  validateSearch: (search: Record<string, unknown>): { tab: MemberTab } => ({
    tab: MEMBER_TABS.parse(search['tab']),
  }),
  component: MemberRoute,
});

function MemberRoute() {
  const { tenant, userId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[
        { label: t('access.members.title') },
        { label: <EntityName tenantId={tenant} kind="user" id={userId} /> },
      ]}
    >
      <MemberDetailPage
        tenantId={tenant}
        userId={userId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
